import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import pt from "./locales/pt.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["en", "fr", "es", "de", "pt"],
        ns: ["common"],
        defaultNS: "common",
        interpolation: { escapeValue: false },
        initImmediate: false,
        resources: {
            en: { common: en },
            fr: { common: fr },
            es: { common: es },
            de: { common: de },
            pt: { common: pt },
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
        },
    });

export default i18n;
